import {
  NationalIdDto,
  PersonalIdentifierDocumentDto,
  PersonalIdentifierType,
} from '@/shared/lib/sj-orm/models/document/personal-identifier.document.dto';

export const isNationalId = (
  document: PersonalIdentifierDocumentDto,
): document is NationalIdDto & PersonalIdentifierDocumentDto => {
  return (
    document?.personalIdentifierType?.toLocaleLowerCase() ===
    PersonalIdentifierType.NATIONAL_ID.toLocaleLowerCase()
  );
};
